import type { CandidatePhoto } from '../types';
import { mockCandidatePhoto } from './mockCandidatePhoto';

export const candidatePhotoMock: CandidatePhoto = mockCandidatePhoto();
